export const getCustomUrl = async (gccBaseUrl, itemId) => {
  return fetch(`${gccBaseUrl}/api/GetOMSIDByExternalId?externalId=${itemId}&siteId=11`);
};